/**
 * OpenAI Ads Measurement Pixel – storefront events for Pupps.
 */
(function () {
  var cfg = window.PuppsOaiq || {};
  var currency = cfg.currency || "GBP";
  var debug =
    !!cfg.debug || /[?&]oaiq_debug=1(?:&|$)/.test(window.location.search);

  function log() {
    if (!debug) return;
    var args = ["[Pupps oaiq]"].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function measure(eventName, data, options) {
    if (typeof window.oaiq !== "function") {
      log("measure skipped, oaiq not available:", eventName);
      return;
    }
    log("measure", eventName, data, options || {});
    window.oaiq("measure", eventName, data, options || {});
  }

  function lineItemsToContents(items) {
    return (items || []).map(function (item) {
      return {
        id: String(item.variant_id || item.id || ""),
        name: item.title || item.product_title || "",
        content_type: "product",
        quantity: Number(item.quantity) || 1,
        amount:
          Number(
            item.final_line_price != null
              ? item.final_line_price
              : item.line_price != null
                ? item.line_price
                : item.price
          ) || 0,
        currency: currency,
      };
    });
  }

  function sumAmount(items) {
    return (items || []).reduce(function (total, item) {
      var line =
        item.final_line_price != null
          ? item.final_line_price
          : item.line_price != null
            ? item.line_price
            : (Number(item.price) || 0) * (Number(item.quantity) || 1);
      return total + (Number(line) || 0);
    }, 0);
  }

  function trackProductView() {
    var product = cfg.product;
    if (!product) {
      log("contents_viewed skipped, no product in PuppsOaiq config");
      return;
    }
    measure("contents_viewed", {
      type: "contents",
      amount: Number(product.price) || 0,
      currency: currency,
      contents: [
        {
          id: String(product.variantId || product.id || ""),
          name: product.name || "",
          content_type: "product",
          quantity: 1,
          amount: Number(product.price) || 0,
          currency: currency,
        },
      ],
    });
  }

  function trackItemsAdded(items) {
    var contents = lineItemsToContents(items);
    if (!contents.length) {
      log("items_added skipped, no line items");
      return;
    }
    measure("items_added", {
      type: "contents",
      amount: sumAmount(items),
      currency: currency,
      contents: contents,
    });
  }

  function trackCheckoutStarted(cart) {
    var items = cart && cart.items ? cart.items : [];
    measure("checkout_started", {
      type: "contents",
      amount: Number(cart && cart.total_price) || sumAmount(items),
      currency: currency,
      contents: lineItemsToContents(items),
    });
  }

  function fetchCart() {
    if (!window.Shopify || !Shopify.routes || !Shopify.routes.root) {
      log("cart.js skipped, Shopify.routes not available");
      return Promise.resolve(null);
    }
    return fetch(Shopify.routes.root + "cart.js")
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function onVariantAdd(e) {
    var detail = (e && e.detail) || {};
    log("variant:add received", detail);
    trackItemsAdded(detail.items || []);
  }

  function bindCheckoutClicks() {
    document.addEventListener(
      "click",
      function (e) {
        var target = e.target.closest('[name="checkout"], [href*="/checkout"]');
        if (!target) return;
        log("checkout click detected");
        fetchCart().then(function (cart) {
          if (cart) trackCheckoutStarted(cart);
        });
      },
      true
    );
  }

  function init() {
    log("init", {
      pageType: cfg.pageType,
      currency: currency,
      product: cfg.product || null,
      oaiqType: typeof window.oaiq,
    });

    if (cfg.pageType === "product") {
      trackProductView();
    }

    document.addEventListener("variant:add", onVariantAdd, true);
    bindCheckoutClicks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
